<div *ngIf="createForm">
  <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 13">
    <div class="row">
      <div class="col-md-11">
        <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
          <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
            <app-form-errors
              [stepid]="'_STEP_ID_' + (i+1)"
              [linkForRouter]="linkForRouter"
            >
            </app-form-errors>
          </div>
        </div>

        <div [class]="formClass">
          <fieldset>
            <legend *ngIf="indexPage > 0 && indexPage < 13">
              {{ getIntitule(indexPage) | translate }}
            </legend>

            <app-step1common
              [uid]="getUidCommon(1)"
              [parentForm]="form"
              [disabled]="disabled"
              [mapa]="ann.mapa"
              *ngIf="indexPage === 1"
              [linkForRouter]="linkForRouter"
              [formName]="formName"
            ></app-step1common>
            <app-step2
              [uid]="getUid(2)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 2"
              [linkForRouter]="linkForRouter"
            >
            </app-step2>
            <app-step3
              [uid]="getUid(3)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 3"
              [linkForRouter]="linkForRouter"
            >
            </app-step3>
            <app-step4
              [uid]="getUid(4)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 4"
              [linkForRouter]="linkForRouter"
            >
            </app-step4>
            <app-step5
              [uid]="getUid(5)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 5"
              [linkForRouter]="linkForRouter"
            >
            </app-step5>
            <app-step6
              [uid]="getUid(6)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 6"
              [linkForRouter]="linkForRouter"
            >
            </app-step6>
            <app-step7
              [uid]="getUid(7)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 7"
              [linkForRouter]="linkForRouter"
            >
            </app-step7>
            <app-step8
              [uid]="getUid(8)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 8"
              [linkForRouter]="linkForRouter"
            >
            </app-step8>
            <app-step9
              [uid]="getUid(9)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 9"
              [linkForRouter]="linkForRouter"
            >
            </app-step9>
            <app-step10
              [uid]="getUid(10)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 10"
              [linkForRouter]="linkForRouter"
            >
            </app-step10>
            <app-step11
              [uid]="getUid(11)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 11"
              [linkForRouter]="linkForRouter"
            >
            </app-step11>
            <app-step12
              [uid]="getUid(12)"
              [parentForm]="form"
              [disabled]="disabled"
              [initial]="ann.mapa.initialFromMAPA"
              *ngIf="indexPage === 12"
              [linkForRouter]="linkForRouter"
            >
            </app-step12>
            <div class="text-danger" *ngIf="!isFormValid">
              ce formulaire comporte des erreurs
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
